// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root___Gf79","vLegacy":"SelectSecondary_vLegacy__3SSXB","error":"SelectSecondary_error__3kBGj","disabled":"SelectSecondary_disabled__1EQwa"};